import { authService } from './auth.service';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

export interface DashboardStats {
  activeProjects: number;
  totalClients: number;
  monthlyRevenue: number;
  averageProgress: number;
  recentProjects: Array<{
    id: string;
    name: string;
    status: string;
    progress: number;
    budget: number;
    clientName: string;
    updatedAt: number;
  }>;
  recentActivity: Array<{
    id: string;
    action: string;
    userName: string;
    timestamp: number;
    details: any;
  }>;
  recentDocuments: Array<{
    id: string;
    name: string;
    type: string;
    projectName: string;
    uploadedBy: string;
    signed: boolean;
    createdAt: number;
  }>;
  alerts: {
    overdueInvoices: number;
    pendingChangeOrders: number;
    staleProjects: number;
  };
}

export const adminDashboardService = {
  async getStats(): Promise<DashboardStats> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/admin/dashboard`);
    return response.data;
  },
};